import React, { useEffect, useState } from "react";
import "./index.scss";
import * as _ from "lodash";
import * as Moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  addProfileTrigger,
  editProfileTrigger,
  listProfileTriggerByProfileId,
  readProfileTrigger,
} from "../../../../../../store/profile-trigger/thunkAction";
import TriggerCondition from "../../../../../../components/trigger/condition";
import TriggerActions from "../../../../../../components/trigger/action";
import {
  sendNotifyIziMessageError,
  sendNotifyIziMessageSuccess,
} from "../../../../../../utils/event";
import { profileTriggerAction } from "../../../../../../store/profile-trigger/slice";

const AddTrigger = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const profileId = _.get(params, "id");
  const triggerId = _.get(params, "triggerId");
  const [allConditions, setAllConditions] = useState([]);
  const [anyConditions, setAnyConditions] = useState([]);
  const [actions, setActions] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [provider, setProvider] = useState("");
  const [name, setName] = useState("");

  useEffect(() => {
    dispatch(listProfileTriggerByProfileId({ profileId, filter: {} }));
  }, [dispatch, profileId]);

  useEffect(() => {
    if (triggerId) {
      dispatch(readProfileTrigger(triggerId));
    } else {
      dispatch(profileTriggerAction.clearProfileTrigger());
    }
  }, [dispatch, triggerId]);

  const profileTriggerManage = useSelector(
    (state) => state.profileTriggerManage
  );
  const triggers = _.get(profileTriggerManage, "triggers", []);
  const trigger = _.get(profileTriggerManage, "trigger", {});
  const isLoadingAddProfileTrigger = _.get(
    profileTriggerManage,
    "isLoadingAddProfileTrigger",
    false
  );

  useEffect(() => {
    setAllConditions(_.get(trigger, "allConditions", []));
    setAnyConditions(_.get(trigger, "anyConditions", []));
    setActions(_.get(trigger, "actions", []));
    setIsActive(_.get(trigger, "isActive", false));
    setProvider(_.get(trigger, "provider", ""));
    setName(_.get(trigger, "name", ""));
  }, [trigger]);

  const validateTrigger = () => {
    if (!name && !name.trim()) {
      sendNotifyIziMessageError(t("profile.trigger_name_is_require"));
      return false;
    }
    if (_.isEmpty(allConditions) && _.isEmpty(anyConditions)) {
      sendNotifyIziMessageError(t("profile.condition_is_require"));
      return false;
    }
    if (_.isEmpty(actions)) {
      sendNotifyIziMessageError(t("profile.action_is_require"));
      return false;
    }
    return true;
  };

  const onSaveTrigger = async () => {
    const isOk = validateTrigger();
    if (!isOk) {
      return;
    }
    const data = {
      allConditions,
      anyConditions,
      actions,
      isActive,
      position: triggers.length + 1,
      provider,
      name,
      lastUpdateTime: +Moment.utc(),
    };

    if (triggerId) {
      try {
        await dispatch(editProfileTrigger({ id: triggerId, data })).unwrap();
        sendNotifyIziMessageSuccess(t("profile.profile_trigger_save_success"));
      } catch (error) {
        sendNotifyIziMessageError(t("profile.profile_trigger_save_error"));
      }

      return;
    }

    if (isLoadingAddProfileTrigger) {
      return;
    }

    try {
      const result = await dispatch(
        addProfileTrigger({
          profileId,
          addTime: +Moment.utc(),
          ...data,
        })
      ).unwrap();
      const newTriggerId = _.get(result, "_id");

      sendNotifyIziMessageSuccess(t("profile.profile_trigger_save_success"));
      navigate(`/profile/${profileId}/trigger/edit/trigger-id/${newTriggerId}`);
    } catch (error) {
      sendNotifyIziMessageError(t("profile.profile_trigger_save_error"));
    }
  };

  return (
    <div className="container">
      <div className="card bg-white border-0">
        <div className="card-body mb-5">
          <div className="row header-title mb-4">
            <div className="col-lg-6">
              <h3 className="color-pri">
                {t("settings.profile.profile_trigger.create_profile_trigger")}
              </h3>
            </div>
            <div className="col-lg-6 text-start text-lg-end align-self-center">
              <a
                className="default-link"
                href={`#/profile/${profileId}/trigger`}
              >
                <i className="fa fa-arrow-left"></i>{" "}
                {t("settings.profile.profile_trigger.trigger_profile")}
              </a>
            </div>
          </div>
          <hr className="mb-4 mt-4" />

          <div className="row">
            <div className="col-lg-3"></div>
            <div className="col-lg-7">
              <div className="row g-4">
                <div className="col-12">
                  <label className="form-label text-uppercase">
                    {t("settings.profile.profile_trigger.status")}
                  </label>
                  <label className="form-check form-switch gap-2 d-flex align-items-center">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked={isActive}
                      onChange={(e) => setIsActive(e.target.checked)}
                    />
                    <span>
                      {isActive ? t("common.active") : t("common.inactive")}
                    </span>
                  </label>
                </div>
                <div className="col-12">
                  <label className="form-label text-uppercase">
                    {t("settings.profile.profile_trigger.trigger_name")}
                  </label>
                  <input
                    className="form-control"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          <hr className="mb-4 mt-4" />
          <div className="row">
            <div className="col-lg-3">
              <h5 className="title">
                {t("settings.profile.profile_trigger.input_conditions")}
              </h5>
              <div className="color-gray small">
                {t("settings.profile.profile_trigger.input_conditions_desc")}
              </div>
            </div>
            <div className="col-lg-7">
              <div className="">
                <div className="conditions-wraper">
                  <div className="conditions-item border mt-3 p-3 rounded-2 position-relative">
                    <span className="conditions-title rounded-5 btn btn-gray">
                      {t("settings.profile.profile_trigger.trigger_all_desc_1")}{" "}
                      <strong>
                        {t(
                          "settings.profile.profile_trigger.all_condition_strong"
                        )}
                      </strong>{" "}
                      {t("settings.profile.profile_trigger.are_met")}
                    </span>
                    <TriggerCondition
                      config={{
                        onChange: setAllConditions,
                        conditions: allConditions,
                      }}
                    />
                  </div>
                  <div className="conditions-item border mt-5 p-3 rounded-2 position-relative">
                    <span className="conditions-title rounded-5 btn btn-gray">
                      {t("settings.profile.profile_trigger.and")}{" "}
                      <strong>
                        {t(
                          "settings.profile.profile_trigger.any_condition_strong"
                        )}
                      </strong>{" "}
                      {t("settings.profile.profile_trigger.are_met")}
                    </span>
                    <TriggerCondition
                      config={{
                        onChange: setAnyConditions,
                        conditions: anyConditions,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr className="mb-4 mt-4" />
          <div className="row mb-5">
            <div className="col-lg-3">
              <h5 className="title">
                {t("settings.profile.profile_trigger.performs")}
              </h5>
              <div className="color-gray small">
                {t("settings.profile.profile_trigger.performs_decs")}
              </div>
            </div>
            <div className="col-lg-7">
              <TriggerActions
                config={{
                  actions,
                  onChange: setActions,
                  autocompleteOptions: [
                    { id: "support", name: "Support Team" },
                    { id: "billing", name: "Billing Team" },
                  ],
                  onSearch: (term) => console.log("Searching for:", term),
                }}
              />
            </div>
          </div>
          <div className="card-footer">
            <div className="d-flex gap-3 justify-content-center align-items-center">
              <button onClick={onSaveTrigger} className="btn btn-primary">
                {t("common.save")}
              </button>
              <button
                onClick={() => {
                  navigate(`/profile/${profileId}/trigger`);
                }}
                className="btn btn-gray btn-outline-gray"
              >
                {t("common.exit")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTrigger;
